const initialState = {
    name: "MARCEL",
    iduser: "0",
    categoria: "ADMIN",
    key: '0',
    fone: '0',
    endereco: '',
    numero: '',
    bairro: '',
    referencia: '',
    email: '',
    id_bairro: '0',
    taxa: '0'  
}

const EntregaReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_ENTREGA":
            return { ...state, 
                name:       action.payload.name, 
                iduser:     action.payload.id,
                categoria:  action.payload.categoria,
                key:        action.payload.key,
                fone:       action.payload.fone,
                endereco:   action.payload.endereco,
                numero:     action.payload.numero,
                bairro:     action.payload.bairro,
                referencia: action.payload.referencia,
                email:      action.payload.email,
                id_bairro:  action.payload.id_bairro,
                taxa:       action.payload.taxa  }
            //break;
        default:
            break;
    }

    return state;
}

export default EntregaReducer;